<template>
  <Page class="detailView">
    <div>
      <div class="pageContent-title">资料信息</div>
      <div class="detailView-with-actions mt-5">
        <a-form class="form flex-form" :form="form" :colon="false">
          <div class="form-base-width">
            <a-form-item label="资料名称" required>
              <a-input
                v-decorator="[
                  'materialTemplateName',
                  {
                    rules: [{ required: true, message: '请输入' }],
                  },
                ]"
              ></a-input>
            </a-form-item>
          </div>
          <div class="form-base-width">
            <a-form-item label=" 名称备注" required>
              <a-input
                v-decorator="[
                  'templateRemark',
                  {
                    rules: [{ required: true, message: '请输入' }],
                  },
                ]"
              ></a-input>
            </a-form-item>
          </div>
          <div class="form-base-width">
            <a-form-item label="国家" required>
              <!-- <a-select
                v-decorator="[
                  'countryId',
                  {
                    rules: [{ required: true, message: '请选择国家' }],
                  },
                ]"
                placeholder="请选择"
                allowClear
                :options="countryList"
              ></a-select> -->
              <div class="inputBox">
                <a-select
                  mode="multiple"
                  style="width: 100%"
                  placeholder="请选择"
                  v-decorator="[
                    'countryInfoList',
                    {
                      rules: [{ required: true, message: '请选择国家' }],
                    },
                  ]"
                  @change="handleChange"
                >
                  <a-select-option v-for="item in countryList" :key="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
                <a-button style="margin-left: 10px" type="primary" @click="selectAll">全选</a-button>
              </div>
            </a-form-item>
          </div>
          <a-form-item label="图片示例">
            <PictureCardUpload
              v-decorator="['samplePictureUrl']"
              preview
              :itemWidth="150"
              :itemHeight="187"
            ></PictureCardUpload>
          </a-form-item>
          <a-form-item label="资料模版">
            <PictureCardUpload
              v-decorator="['templateFileUrl']"
              preview
              :fileType="''"
              :tips="'点击上传'"
              :beforeUpload="beforeUpload"
              :itemWidth="198"
              :itemHeight="124"
            ></PictureCardUpload>
          </a-form-item>
          <a-form-item label="资料描述" :wrapperCol="{ style: 'width: 100%' }" required>
            <RichText
              v-decorator="['description', { rules: [{ required: true, message: '请输入资料描述' }] }]"
            ></RichText>
          </a-form-item>
        </a-form>
      </div>
      <div class="detailView-actions">
        <a-button class="app-btn" type="default" @click="goBackOne">返回</a-button>
        <a-button class="app-btn" type="primary" @click="doSave">保存</a-button>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { toolMixin, queryViewMixin } from '@/utils/mixin'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload.vue'
import RichText from '@/components/RichText'
import Reg from '@/utils/reg'
import { getCountryList } from '@/service/getData'

export default {
  components: {
    Page,
    PictureCardUpload,
    RichText,
  },
  props: {},
  mixins: [toolMixin, queryViewMixin],
  data() {
    return {
      richForm: {
        serviceContent: '',
        warmHint: '',
      },
      form: this.$form.createForm(this),
      dataSource: [],
      countryList: [],
      area: [],
      Reg,

      countryObjList: [],
    }
  },
  async mounted() {
    const id = this.$route.query.materialTemplateId
    if (id) {
      this.initFormById(id)
    }
    this.countryList = await getCountryList()
  },
  computed: {},
  methods: {
    handleChange(e) {
      console.log('e', e)
      this.countryObjList = e
    },
    beforeUpload() {},
    goBackOne() {
      this.$router.go(-1)
    },
    doSave() {
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          console.log('params', params)
          let list = []
          for (let i = 0; i < this.countryList.length; i++) {
            for (let j = 0; j < this.countryObjList.length; j++) {
              if (this.countryList[i].value === this.countryObjList[j]) {
                list = [
                  ...list,
                  {
                    countryId: this.countryList[i].value,
                    countryName: this.countryList[i].label,
                  },
                ]
              }
            }
          }

          params.countryInfos = list
          const materialTemplateId = this.$route.query.materialTemplateId
          if (materialTemplateId) {
            params.materialTemplateId = materialTemplateId
          }
          params.productType = 1
          try {
            await this.$axios.post('/visa/admin/productMaterialTemplate/save', { data: params })
            this.$message.success('操作成功!')
            this.$router.go(-1)
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    async initFormById(id) {
      const { data, success } = await this.$axios.post(
        '/visa/admin/productMaterialTemplate/queryByTemplateId',
        {
          data: {
            materialTemplateId: id,
          },
        }
      )
      if (success) {
        this.$nextTick(() => {
          data.countryId = Number(data.countryId)
          ;(data.countryInfoList = data.countryInfoList?.map((item) => Number(item)) || []),
            this.safeSetFieldsValue$t(this.form, { ...data })
          this.countryObjList = data.countryInfoList || []
        })
      }
    },
    selectAll() {
      const selected = this.form.getFieldValue('countryInfoList') || []
      // 只要包含未被选中的
      const shouldSelectAll = this.countryList.some((item) => !selected.includes(item.value))

      this.safeSetFieldsValue$t(this.form, {
        countryInfoList: shouldSelectAll ? this.countryList.map((item) => item.value) : [],
      })

      this.countryObjList = shouldSelectAll ? this.countryList.map((item) => item.value) : []
    },
  },
}
</script>

<style scoped lang="less">
// .ant-tag {
//   font-size: 16px;
//   line-height: 28px;
// }
.inputBox {
  display: flex;
}
</style>
